<template>
  <div class="image-verify-code">
    <el-form-item :prop='imageCode'>
      <div class="verify-input">
        <el-input v-focus="focus" v-model="imageCode" class="img-code" placeholder="请输入图片验证码" maxlength="4"
                  @keyup.enter.native="login" />
      </div>
      <div class="verify-img">
        <img @click.stop="changeCode" alt="点击更换" title="点击更换" :src="imageSrc"/>
      </div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'image-verify-code',
  props: {
    // 默认不聚焦
    focus: {
      type: [Number, String, Boolean],
      default: true
    }
  },
  mounted () {
    this.changeCode()
  },
  data () {
    return {
      imageSrc: '',
      imageCode: ''
    }
  },
  watch: {
    'imageCode' (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    changeCode () {
      // 调用后台获取图片
      this.imageSrc = `/auth-api/verificationCode.jpg?t=` + new Date().getTime()
    },
    login () {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="scss">
  .image-verify-code {
    .verify-input {
      width: 194px;
    }
    .verify-input, .verify-img {
      display: inline-block;
      img {
        border-radius: 5px;
        cursor: pointer;
      }
    }
    .verify-img {
      width: 120px;
      height: 38px;
      border-radius: 4px;
      background-color: #e3e2f0;
      vertical-align: middle;
    }
    .img-code>input {
      height: 38px;
      background-color: #21252e;
      -webkit-border-radius: 10px;
      padding: 0 0 0 15px;
      color: #606266;
      border-bottom-width: 1px
    }
  }
  .el-input__inner:focus {
    border-color:#FFF;
    outline: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/system/image-verify-code.vue